import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { SUB_MODULE } from "../apiRoutes";

interface SubmoduleResponse {
  data: any;
}

const fetchSubmoduleDetail = async (id: string) => {
  const response = await axiosAuth.get<SubmoduleResponse>(
    `${SUB_MODULE}${id}`
  );
  return response.data;
};

const useGetSubmoduleDetailQuery = (
  id?: string,
  queryParams?: UseQueryOptions<any, Error, any, ["submoduleDetail", string | undefined]>
) =>
  useQuery<any, Error, any, ["submoduleDetail", string | undefined]>({
    queryKey: ["submoduleDetail", id],
    queryFn: () => fetchSubmoduleDetail(String(id)),
    enabled: Boolean(id),
    ...(queryParams as any),
  });

export default useGetSubmoduleDetailQuery;


